import React from "react";
import { Sheet } from "react-modal-sheet";
interface BottomSheetProps {
  visible: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
}

const BottomSheet: React.FC<BottomSheetProps> = ({
  visible,
  onClose,
  children,
  title,
}) => {
  return (
    <Sheet isOpen={visible} onClose={onClose} snapPoints={[0.7]}>
      <Sheet.Container>
        <Sheet.Header>
          <div className="flex items-center justify-center pt-2">
            <div className="w-12 h-1 bg-gray-400"></div>
          </div>
          <div className="p-4 border-b shadow-md">
            <span className="text-xl font-bold">{title}</span>
          </div>
        </Sheet.Header>
        <Sheet.Content>
          <Sheet.Scroller>{children}</Sheet.Scroller>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop onTap={onClose} />
    </Sheet>
    // <Modal
    //   animationType="none"
    //   transparent={true}
    //   visible={visible}
    //   onRequestClose={onClose}
    // >
    //   <Pressable onPress={onClose} className="flex-1">
    //     <View className="flex-1 bg-black bg-opacity-50">
    //       <Animated.View
    //         className="bg-white rounded-t-lg absolute bottom-0 w-full"
    //         style={{
    //           transform: [
    //             {
    //               translateY: slideAnim.interpolate({
    //                 inputRange: [0, 1],
    //                 outputRange: [300, 0],
    //               }),
    //             },
    //           ],
    //           maxHeight: "80%",
    //         }}
    //       >
    //         <View className="flex-row justify-between items-center mb-4 px-6 pt-6">
    //           <Text category="h6">{title}</Text>
    //           <Pressable onPress={onClose}>
    //             <Ionicons name="close" size={24} color="black" />
    //           </Pressable>
    //         </View>
    //         <ScrollView className="flex-1 mb-4 px-6">{children}</ScrollView>
    //       </Animated.View>
    //     </View>
    //   </Pressable>
    // </Modal>
  );
};

export default BottomSheet;
